
import { mapState, mapMutations } from "vuex";

export default {
  computed: {
    articleCategory() {
      return this.$route.params._category;
    },
    ...mapState("blog", {
      categories: (state) => state.categories.data,
      category: (state) => state.category.data,
    }),
  },
  async fetch() {
    this.categories && (await this.$store.dispatch("blog/getCategories"));
  },
  methods: {
    ...mapMutations("blog", ["GET_CATEGORY"]),
    selectCategory(cat) {
      !cat.slug ? this.GET_CATEGORY(cat.name) : this.GET_CATEGORY(cat.slug);
    },
  },
};
